import {SxProps, Theme} from '@mui/material';
import {pillShapePhoneSx} from 'src/components/common/pillFit.sx';
import theme from 'src/theme';

/**
 * What the session took, as a pill beside its state.
 *
 * Energy is the one number somebody scrolling a list of sessions is actually after, and as the
 * eleventh row of a card nobody ever reached it.
 */
export const energyPillSx: SxProps<Theme> = {
    ...pillShapePhoneSx,
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primaryColor.A50,
    border: `1px solid ${theme.palette.primaryColor.A100}`,
};
